import { render, staticRenderFns } from "./SalesOrderDialog.vue?vue&type=template&id=5518893e"
import script from "./SalesOrderDialog.vue?vue&type=script&lang=js"
export * from "./SalesOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports